const demos = {
  all_demos: 'Demo accounts',
  create: 'Create demo',
  mode: 'Mode',
  mode_reuse: 'Use existing demo account',
  mode_new: 'Create new user',
  account_type: 'User type',
  type_student: 'Student',
  type_teacher: 'Teacher',
  country: 'Country',
  school: 'Demo school',
  grade: 'Grade',
  account: 'Account',
  demo_user: 'Student/Teacher',
  client: 'Client',
  reason: 'Reason',
  starting_date: 'Start date',
  finish_date: 'Expiration date',
  firstname: 'First name',
  lastname: 'Last name',
  identifier: 'ID or email',
  created_title: 'Demo link created',
  link: 'Link',
  copy_link: 'Copy link',
  copied: 'Link copied',
  revoke: 'Revoke',
  revoke_confirm: 'Revoke this demo access?',
  login_count: 'Logins',
  last_login: 'Last login',
  empty: 'No demo accounts created',
  create_error: 'Could not create the demo access',
  load_error: 'Could not load demo accounts. Please try again.',
  revoke_error: 'Could not revoke the demo access. Please try again.',
  revoked: 'Demo access revoked.',
};

export default demos;
